import axios from "axios"
import { REACT_APP_API } from '../../config'

const FILES_ROOT = '/files'

/**
 * Elimina todos los archivos que coincidan con los IDs recibidos
 * @param {Array<{id: String}>} fileIds Id de las asociaciones a eliminar
 */
export const deleteFilesById = async (fileIds) => {
    const body = { file_ids: fileIds };

    const response = await axios.put(REACT_APP_API + `${FILES_ROOT}/bulkDelete`, body);

    return response.data;
}
